import { Box } from "theme-ui";
import { SiteLogo, Link } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Box,
  SiteLogo,
  Link,
  React
};